import * as actionsType from "../actions/types";

const initialState = {};

export default function filteredProductsReducer(state = initialState, action) {
    // let tempState = { ...state };
    switch (action.type) {
        case actionsType.SET_FILTERED_PRODUCTS:
            const { response, filters, pageNumber } = action.payload;
            // console.log("filtered products list in reducer: ", list);
            return { filters, pageNumber, unSkippedSize: response.unSkippedSize, list: response.list };
        default:
            return state;
    }
}